window.onload = function (){
    const tableOfContents = document.createElement("div");
    const tableOfContents_list = document.createElement("ul");
    const tableOfContents_heading = document.createElement("h6");

    let headingsList = document.getElementById("MainContent").querySelectorAll("h5");
    tableOfContents.setAttribute("class", "table-of-content");
    tableOfContents_list.setAttribute("class", "table-of-content-list");

    tableOfContents_heading.innerText = 'Table of content';
    tableOfContents_heading.setAttribute("class", "table-of-content-heading");

    var tableItem_head = document.createElement('li');
    tableItem_head.appendChild(tableOfContents_heading);
    tableOfContents_list.appendChild(tableItem_head);

    for (var i = 0; i < headingsList.length; i++){
        headingsList[i].setAttribute("id", i);
        var tableItem = document.createElement('li');
        var tableLink = document.createElement('a');
        var linkText = document.createTextNode(headingsList[i].innerText);
        tableLink.appendChild(linkText);
        tableLink.title = headingsList[i].innerText;
        tableLink.href = '#' + headingsList[i].id;
        tableItem.appendChild(tableLink);
        tableOfContents_list.appendChild(tableItem);
    }
    const content = document.querySelector(".main-page-container");
    tableOfContents.appendChild(tableOfContents_list);
    content.appendChild(tableOfContents);
}
